<template>
  <div class="selector" :class="selectorClasses">
    <div v-for="(l, k) in lines" :key="`${k}-selector-line`">
      <span class="selector-title">
        <strong>{{ l.title }} </strong>
        <small v-if="l.subtitle">({{ l.subtitle }})</small>
        <br />
      </span>
      <span v-for="(c, i) in l.choices"
            :key="`${k}-selector-line-${i}`"
            v-tooltip.unenterable="c.tooltip">
        <btn @click="l.select(i)"
             v-show="!locked || c.selected"
             size="sm"
             :type="c.type"
             :active="c.active"
             :disabled="c.disabled || locked">
          <span class="selector-btn-text-md">
            {{ c.label }}
          </span>
          <span class="selector-btn-text-xs">
            {{ c.shortLabel ? c.shortLabel : c.label }}
          </span>
        </btn>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'selector',

  props: {
    type: {
      type: String,
      default: 'default'
    },

    lines: {
      type: Array,
      required: true
    },

    short: {
      type: Boolean,
      default: false
    },

    locked: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    selectorClasses: function () {
      let result = `selector-${this.type}`
      if (this.short) {
        result += ' selector-with-short-names'
      }
      return result
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.selector {
  display: block;
  background-color: lighten(@brand-warning, 35%);
  color: darken(@brand-warning, 15%);
  padding: 0.5rem;

  .btn {
    margin: 0.1rem;
  }
  .selector-btn-text-xs {
    display: none;
  }
}

.selector:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.selector:last-child {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  margin-bottom: 0.4rem;
}

.selector-with-short-names {
  @media (min-width: 0) and (max-width: @screen-sm-max) {
    .btn-sm {
      font-size: 80%;
    }
    .selector-title {
      display: none;
    }

    .selector-btn-text-md {
      display: none;
    }

    .selector-btn-text-xs {
      display: block;
    }
  }

  @median (min-width: @screen-md-min) {
    .selector-btn-text-xs {
      display: none;
    }
  }
}

.selector-dark {
  background-color: lighten(@brand-warning, 25%);
}
</style>
